import { useMutation } from '@tanstack/react-query';

import { PayRequestType } from '~/shared/api/types/catalog';

import { payOrder } from '../api/payOrder/payOrder';

export const usePayOrder = () => {
  const mutation = useMutation({
    mutationKey: ['payOrder'],
    mutationFn: (params: PayRequestType) => payOrder(params),
  });

  return mutation;
};
